export default __webpack_public_path__ + "static/media/star-selected.d2655331.svg";